<script>
	import PublicDocument from '../../PublicDocument.svelte';
	let { data } = $props();
</script>

<PublicDocument document={data.document} />
